'use client';
import styled from 'styled-components';

export const StyledTrack = styled.div`
  height: 10px;
  width: 100%;
  background-color: #784d7c;
  border-radius: 5px;
`;

export const StyledIndicator = styled.span`
  display: block;
  background-color: ${props =>
    props.theme.colors.get(props.$color, props.theme.colors.secondary.yellow)};
  height: 100%;
  width: ${props => props.progress}%;
  transition: width 1s ease-in-out;
  border-radius: 5px;
`;
